import React from "react";
import Sucursales from "./Sucursales";
import { useAuth } from "../Context";

interface FiltroSucursalProps {
  onSucursalChange: (sucursal: string) => void;
  value?: string;
}

/**
 * Componente reutilizable para mostrar el filtro de sucursal solo a admin o Gerente General.
 * Si no tiene privilegios, no renderiza nada.
 */
const FiltroSucursal: React.FC<FiltroSucursalProps> = ({ onSucursalChange, value }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) return null;
  return (
    <div style={{ minWidth: 250 }}>
      <Sucursales onSucursalChange={onSucursalChange} />
    </div>
  );
};

export default FiltroSucursal;
